<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/family' }">
        <app-i18n code="entities.family.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.family.view.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.family.view.title"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="loading" v-loading="loading"></div>

      <app-family-view-toolbar v-if="record"></app-family-view-toolbar>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        @submit.prevent.native
        class="form"
        v-if="record"
      >
        <app-view-item-text :label="fields.id.label" :value="presenter(record, 'id')"></app-view-item-text>

        <app-view-item-text :label="fields.firstName.label" :value="presenter(record, 'firstName')"></app-view-item-text>
        
        <app-view-item-text :label="fields.lastName.label" :value="presenter(record, 'lastName')"></app-view-item-text>
        
        <app-view-item-text :label="fields.gender.label" :value="presenter(record, 'gender')"></app-view-item-text>

        <app-view-item-text :label="fields.phoneNumber.label" :value="presenter(record, 'phoneNumber')"></app-view-item-text>
        
        <app-view-item-text :label="fields.email.label" :value="presenter(record, 'email')"></app-view-item-text>

        <app-view-item-text :label="fields.createdAt.label" :value="presenter(record, 'createdAt')"></app-view-item-text>

        <app-view-item-text :label="fields.updatedAt.label" :value="presenter(record, 'updatedAt')"></app-view-item-text>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import FamilyViewToolbar from '@modules/family/components/family-view-toolbar.vue';
import { FamilyModel } from '@modules/family/family-model';

const { fields } = FamilyModel;

export default {
  name: 'app-family-view-page',

  props: {
    id: {
      type: String,
      required: true
    },
    
    subpropertyId: {
      type: String,
      required: true
    }
  },

  components: {
    [FamilyViewToolbar.name]: FamilyViewToolbar,
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'family/view/record',
      loading: 'family/view/loading',
    }),

    fields() {
      return fields;
    },
  },

  async created() {
    await this.doFind({ id: this.id, subpropertyId: this.subpropertyId});
  },

  methods: {
    ...mapActions({
      doFind: 'family/view/doFind',
    }),

    presenter(record, fieldName) {
      return FamilyModel.presenter(record, fieldName);
    },
  },
};
</script>
